module.exports = __webpack_public_path__ + "static/media/nobg.19d5cc03.png";